import { unauthenticatedPagePromo } from '@gonfalon/dogfood-flags/dogfood-flags';

export enum UnauthenticatedPageThemes {
  default = 'off',
  dark = 'dark-theme',
}

export enum UnauthenticatedPagePromos {
  disabled = 'off',
  galaxy2025 = 'galaxy-2025',
  reinvent2025 = 'reinvent-2025',
  agentControlLaunch2026 = 'agent-control-launch-2026',
  handsOnWithAgentControl = 'hands-on-with-agentcontrol',
}

export const shouldShowUnauthenticatedPagePromo = () =>
  unauthenticatedPagePromo() !== UnauthenticatedPagePromos.disabled;
